import { Box, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import MapOsmCamera from './MapOsmCamera';
import './style.css';
import VideoWall from './VideoWall';
import { resetVideoSlice } from 'src/features/videoSlice';
import useVehicleTracking from 'src/app/hooks/useVehicleTracking';
import LoadingComponent from 'src/app/components/Loading';

const MapViewCamera = () => {
  const dispatch = useDispatch();
  const query = new URLSearchParams(useLocation().search);
  const showMenu = JSON.parse(query.get('show_menu'));
  const [loading, setLoading] = useState(false);
  const deviceSerial = useSelector(state => state.videoSlice.deviceSerial);

  const listVehicleTracking = useSelector(
    state => state.vehicleSlice.listVehicleTracking
  );
  const listVehicles = listVehicleTracking.filter(vehicle => {
    return vehicle.device_serial === deviceSerial;
  });
  const listCamera4G = deviceSerial ? listVehicles : listVehicleTracking;

  useVehicleTracking();

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      if (deviceSerial) {
        setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 700));
        if (isMounted) setLoading(false);
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [deviceSerial]);

  useEffect(() => {
    return () => {
      dispatch(resetVideoSlice());
    };
  }, []);

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        overflowX: 'hidden',
        height: 'calc(100vh - 66px)'
      }}
      padding={0}
      margin={0}
    >
      {deviceSerial ? (
        <>
          {loading ? (
            <LoadingComponent />
          ) : (
            <Box className="row">
              <Box
                className={showMenu ? 'col-9' : 'col-7'}
                style={{
                  paddingLeft: 52
                }}
              >
                <VideoWall deviceSerial={deviceSerial} />
              </Box>
              <Box
                className={showMenu ? 'col-3' : 'col-5'}
                style={{
                  paddingLeft: 0
                }}
              >
                <MapOsmCamera
                  zoom={13}
                  listCamera4GTracking={listCamera4G}
                  showMenu={showMenu}
                  deviceSerial={deviceSerial}
                />
              </Box>
            </Box>
          )}
        </>
      ) : (
          <Box
            style={{
              width:'100%'
            }}
          >
            <MapOsmCamera
              zoom={13}
              listCamera4GTracking={listVehicleTracking}
              showMenu={showMenu}
              deviceSerial={deviceSerial}
            />
          </Box>
      )}
    </Box>
  );
};

export default React.memo(MapViewCamera);
